module.exports = __webpack_public_path__ + "assets/img/home-form-button.35d53429.png";